// DC3: consulta si el curso tiene constancia normativa asignada.
import api from '../..'

export interface Dc3AttestationAssignedResponse {
  normative: boolean
  assigned: boolean
  name?: string | null
  attestationId?: number | null
}

const getDc3AttestationAssigned = (courseId: number) => {
  return api
    .get<Dc3AttestationAssignedResponse>(
      `administration/courses/${courseId}/dc3_attestation_assigned`
    )
    .then(({ data }) => data)
}

export default getDc3AttestationAssigned
